export default {
  list: {
    addUser: 'Tambah User',
    id: 'ID',
    name: 'Nama',
    email: 'Email',
    phone: 'No Handphone',
    action: 'Action',
    show: 'Menampilkan',
    from: 'dari',
    moreDetail: 'Lihat Rincian'
  },
  create: {
    addUser: 'Tambah User',
    name: 'Nama',
    namePlaceholder: 'Masukan nama',
    email: 'Email',
    emailPlaceholder: 'Masukan email',
    phone: 'No Handphone',
    phonePlaceholder: 'Masukan no handphone',
    password: 'Password',
    passwordPlaceholder: 'Masukan password',
    save: 'Simpan'
  },
  detail: {
    userInfo: 'Info User',
    id: 'ID',
    name: 'Nama',
    email: 'Email',
    phone: 'No Handphone',
    update: 'Update',
    delete: 'Hapus',
    modalTitle: 'Hapus User?',
    modalDesc: 'Apakah Anda yakin untuk menghapus user ini?',
    yes: 'Ya',
    no: 'Tidak'
  }
}
